import Vue from 'vue';
import { GridItemNormalizer } from '../types';

export default class BooleanNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value === true || value === false;
  }

  normalize(value: any) {
    // return Vue.i18n.translate(value === true ? 'Yes' : 'No');
    return value === true ? 'Yes' : 'No';
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  revert(value: string): boolean {
    return value.toLocaleLowerCase() === 'yes';
  }

  getRequiredFields() {
    return null;
  }
}
